/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable react/forbid-prop-types */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap';

import TableRow from '../../common/table/TableRow';

import { SourcesContext } from '../../../containers/sources/SourcesContext';

import Edit from '../../../assets/images/edit.svg';
import Delete from '../../../assets/images/bin.svg';
import execute from '../../../assets/images/confirme-icon.svg';
import ToolTip from '../../common/toolTips/ToolTip';
import { ruleToText } from '../createEditSource/CreateSourceScheduler';

const SourcesListRow = ({ data }) => {
  const {
    id,
    source_identifier,
    licensing_agency,
    license_type,
    state,
    country_code,
    source,
    file_name,
    type,
    license_category,
    approval_type,
    schedule_rule,
  } = data;

  const {
    setShowCreateSourceModal,
    setShowDeleteSourceAlert,
    handleViewUploadedSourceFile,
    executeDAG,
  } = useContext(SourcesContext);

  return (
    <TableRow>
      <td>
        <span>{source_identifier || '-'}</span>
      </td>
      <td>
        <span>{licensing_agency || '-'}</span>
      </td>
      <td>
        <span>{state || '-'}</span>
      </td>
      <td>
        {source && !file_name ? (
          <span className="link-btn" onClick={() => window.open(source, '_blank')}>
            Link
          </span>
        ) : !source && file_name ? (
          <span
            className="link-btn"
            onClick={e => handleViewUploadedSourceFile(file_name, license_category)}
          >
            File
          </span>
        ) : (
          <span>-</span>
        )}
      </td>
      <td>
        <span>{license_category === 2 ? 'Cannabis' : 'Hemp' || '-'}</span>
      </td>
      <td>
        <span>{schedule_rule ? ruleToText(schedule_rule) : '-'}</span>
      </td>
      <td>
        <div className="d-flex">
          <button
            type="button"
            className="table-action-btn fill-btn"
            onClick={() => setShowCreateSourceModal({ data, isCreate: false, show: true })}
          >
            <ToolTip
              icon={Edit}
              placement="bottom"
              imageStyle={{ marginLeft: 'unset !important' }}
              toolTipContent="Edit"
            />
          </button>
          <button
            type="button"
            className="table-action-btn outline-btn"
            onClick={() => setShowDeleteSourceAlert({ id, show: true })}
          >
            <ToolTip
              icon={Delete}
              placement="bottom"
              imageStyle={{ marginLeft: 'unset !important' }}
              toolTipContent="Delete"
            />
          </button>
          <button
            type="button"
            className="table-action-btn outline-btn"
            onClick={() => executeDAG(id)}
          >
            <ToolTip
              icon={execute}
              placement="bottom"
              imageStyle={{ width: '-webkit-fill-available', marginLeft: 'unset !important' }}
              toolTipContent="Execute"
            />
          </button>
        </div>
      </td>
    </TableRow>
  );
};

SourcesListRow.propTypes = {
  data: PropTypes.object.isRequired,
};

export default SourcesListRow;
